'use strict';

const IdeaAdminAPI = require('feedback/infra/api/admin/idea');
const IdeaRepository = require('feedback/domain/repository/idea');

module.exports = class {
    constructor(idea, state, relatedURLs, assignees, estimate, summary, isPublic) {
        this._idea = idea;
        this._json = {
            state: state,
            relatedURLs: relatedURLs,
            assignees: assignees,
            estimate: estimate,
            summary: summary,
            isPublic: isPublic
        };
    }

    execute() {
        return IdeaAdminAPI.update(this._idea.id, this._json)
            .then(ideaJSON => {
                return IdeaRepository.add(ideaJSON);
            });
    }
};



// WEBPACK FOOTER //
// ./feedback/app/service/idea/update.js